import { ChangeDetectionStrategy, Component, Input, OnChanges, ViewChild } from '@angular/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTable, MatTableModule } from '@angular/material/table';
import { FormatDateTimePipe, RolloutPlanChangeHistoryDto } from '@ottobock/remote-update/domain';

@Component({
  selector: 'remote-update-feature-remote-update-dashboard-rollout-plan-change-history',
  templateUrl: './rollout-plan-history.component.html',
  styleUrls: ['./rollout-plan-history.component.css'],
  imports: [MatTableModule, MatPaginatorModule, MatSortModule, FormatDateTimePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true
})
export class RolloutPlanChangeHistory implements OnChanges {
  @ViewChild(MatTable) table!: MatTable<RolloutPlanChangeHistoryDto>;

  @Input() data: RolloutPlanChangeHistoryDto[] = [];

  displayedColumns = ['event', 'user', 'timeStamp', 'remarks'];

  ngOnChanges(): void {
    if (this.data && this.data.length > 0) {
      this.data = [...this.data].sort(
        (a, b) => new Date(b.timeStamp).getTime() - new Date(a.timeStamp).getTime()
      );
    }
  }
}
